import type { SVGProps } from 'react';
const DawnFlagER = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-ER_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-ER_svg__a)">
      <path fill="#29C53F" fillRule="evenodd" d="M22 0v8H0V0z" clipRule="evenodd" />
      <path fill="#579DED" fillRule="evenodd" d="M22 8v8.533H0V8z" clipRule="evenodd" />
      <path fill="#F42D56" fillRule="evenodd" d="m0 16 22-8L0 0z" clipRule="evenodd" />
      <path
        stroke="#FFC63C"
        strokeWidth={1.333}
        d="M9.81 8c0 1.705-1.355 3.067-3 3.067s-3-1.362-3-3.067 1.354-3.067 3-3.067 3 1.362 3 3.067Z"
      />
      <path
        fill="#FFC63C"
        fillRule="evenodd"
        d="M6.286 7.467c.289 0 .523-.24.523-.534a.53.53 0 0 0-.523-.533.53.53 0 0 0-.524.533c0 .295.234.534.524.534M7.333 8c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.523.534c0 .294.234.533.523.533"
        clipRule="evenodd"
      />
      <path
        fill="#FFC63C"
        fillRule="evenodd"
        d="M6.81 6.933c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.533.524.533M6.286 8.533c.289 0 .523-.239.523-.533a.53.53 0 0 0-.523-.533.53.53 0 0 0-.524.533c0 .294.234.533.524.533M7.333 9.067c.29 0 .524-.24.524-.534A.53.53 0 0 0 7.333 8a.53.53 0 0 0-.523.533c0 .295.234.534.523.534"
        clipRule="evenodd"
      />
      <path
        fill="#FFC63C"
        fillRule="evenodd"
        d="M6.286 9.6c.289 0 .523-.239.523-.533a.53.53 0 0 0-.523-.534.53.53 0 0 0-.524.534c0 .294.234.533.524.533M7.333 10.133c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.523.533c0 .295.234.533.523.533"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagER;
